import React from "react";
import { compose, withStateHandlers } from "recompose";
import Transition from "react-transition-group/Transition";

import routes from 'package-common-react/lib/routes';

import AdPopin from "../AdPopin";
import { POPIN_DURATION_IN_MS } from "../AdPopin/style";

import { WinningPanel, WinningPanelBlock, LosingPanel, Score, RegistrationButton, ReplayButton } from "./style";

export default compose(
  withStateHandlers(
    { hasViewedPopin: false },
    {
      closePopin: () => () => ({ hasViewedPopin: true })
    }
  )
)(function PlayResults({ hasWon, score, onReset, hasViewedPopin, closePopin }) {
  return (
    <div>
      {/*<Transition*/}
        {/*in={!hasViewedPopin}*/}
        {/*enter={false}*/}
        {/*timeout={POPIN_DURATION_IN_MS}*/}
      {/*>*/}
        {/*{state => <AdPopin state={state} onClose={closePopin} />}*/}
      {/*</Transition>*/}

      {hasWon ? (
        <WinningPanel>
          <h1 className="heading">Félicitations&nbsp;!</h1>
          <p className="subheading">Vous êtes un as en culture générale&nbsp;!</p>
          <WinningPanelBlock>
            Pour recevoir par e-mail
            <strong>vos 15€ offerts*</strong>
            <div>
              <RegistrationButton to={routes.registration.to({ type: "individual" })}>
                Cliquez-ici
              </RegistrationButton>
            </div>
          </WinningPanelBlock>
          <p className="legal">
            * Bons d'achat de 15€ TTC (hors pneumatique).<br />
            Bons d'achat valables du 01/09 au 31/10/2018<br />
            Offre non cumulable avec d'autres opérations en cours.<br />
            Sur présentation du mail reçu.
          </p>
        </WinningPanel>
      ) : (
        <LosingPanel>
          <h1 className="heading">Dommage&hellip;</h1>
          <Score>
            {score.number} / {score.total}
          </Score>
          <p className="subheading">Vous devez encore réviser vos leçons&nbsp;!</p>
          <p className="text">Tentez à nouveau votre chance&nbsp;!</p>
          <ReplayButton onClick={onReset}>Rejouer</ReplayButton>
        </LosingPanel>
      )}
    </div>
  );
});



// WEBPACK FOOTER //
// ./src/components/PlayResults/index.js